export default __webpack_public_path__ + "2c777a7d8978a2af97d55c8cd7545ef3.svg";